import { Link } from "react-router-dom";
import React from "react";
import { API_BASE_URL } from "../config";

function CategoryCard({ category, linkTo }) {
  return (
    <div className="category-card"
    onMouseMove={(e) => {
  const rect = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--x", `${e.clientX - rect.left}px`);
  e.currentTarget.style.setProperty("--y", `${e.clientY - rect.top}px`);
}}>
      <Link to={linkTo || `/c/${category.id}`}>
        <img
        src={`${API_BASE_URL}/images/categories/${category.image || 'default.jpg'}`}
        alt={category.name}
        loading="lazy"
        decoding="async"
      />
      <div className="category-info">
        <h3>{category.name}</h3>
        </div>
      </Link>
    </div>
  );
}

export default CategoryCard;




